import { Injectable } from '@angular/core';
import {
  Configuration,
  ImportsService,
  ModulesImportsEndpointsContractsImportPointsRaceRequestModel,
} from '../../api-client';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { ConfigService } from '../config/config.service';
import { LoggingService } from '../shared/logging/logging.service';

@Injectable({
  providedIn: 'root',
})
export class ImportService extends ImportsService {
  constructor(
    httpClient: HttpClient,
    config: Configuration,
    configService: ConfigService,
    private loggingService: LoggingService
  ) {
    super(httpClient, config.basePath!, config);

    // get tournament navItem from config navigation
    const tournamentsNavRoute = configService.config?.navigation?.find(
      (item) => item.name === 'Tournaments'
    );

    if (tournamentsNavRoute) {
      this.readonly = tournamentsNavRoute.readonly || false;
    } else {
      this.loggingService.warn('Tournaments navigation route not found in config', 'ImportService');
      this.readonly = false;
    }
  }

  readonly: boolean = false;

  importEmptyTournament(tournamentId?: number): Observable<any> {
    return this.readonly
      ? of()
      : this.importsSourceTypeTournamentsTournamentIdPost(
        'Empty',
        tournamentId?.toString()!,
        false,
        false
      );
  }

  importTournament(
    tournamentId?: number,
    sourceType: string = 'LPGA',
    importCourses: boolean = true,
    importPlayers: boolean = true
  ): Observable<any> {
    return this.readonly
      ? of()
      : this.importsSourceTypeTournamentsTournamentIdPost(
        sourceType,
        tournamentId?.toString()!,
        importCourses,
        importPlayers
      );
  }

  importPointsRaceRankings(
    tournamentId?: number,
    sourceType: string = 'LPGA',
    pointsRaceName?: string,
    replaceExisting: boolean = true
  ): Observable<any> {
    return this.readonly
      ? of()
      : this.importsSourceTypeTournamentsTournamentIdPointsRaceRankingsPost(
        sourceType,
        tournamentId?.toString()!,
        {
          pointsRaceName,
          replaceExisting,
        } as ModulesImportsEndpointsContractsImportPointsRaceRequestModel
      );
  }

  importMissingPointsRacePlayers(
    tournamentId?: number,
    sourceType: string = 'LPGA'
  ): Observable<any> {
    return this.readonly
      ? of()
      : this.importsSourceTypeTournamentsTournamentIdMissingPointsRacePlayersPost(
        sourceType,
        tournamentId?.toString()!
      );
  }

  importPlayers(tournamentId?: number): Observable<any> {
    return this.readonly
      ? of()
      : this.importsSourceTypeTournamentsTournamentIdPlayersPost(
        'LPGA',
        tournamentId?.toString()!
      );
  }

  importCourses(tournamentId?: number): Observable<any> {
    return this.readonly
      ? of()
      : this.importsSourceTypeTournamentsTournamentIdCoursesPost(
        'LPGA',
        tournamentId?.toString()!
      );
  }

  importPlayersFromXml(tournamentId: string, file: File, replaceExisting: boolean = false): Observable<any> {
    if (this.readonly) {
      return of();
    }

    return this.importsXmlTournamentsTournamentIdPlayersPostForm(
      tournamentId,
      file,
      replaceExisting
    );
  }
}
